import FurnishingOrderTypeSelectField from "./furnishing-order-type-select-field";



const FurnishingFields = {
    OrderTypeSelect  : FurnishingOrderTypeSelectField,
}

export default FurnishingFields;